module.exports = __webpack_public_path__ + "img/img-tit-store.60ab5ff7.jpg";